import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import moment from 'moment';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'DESCRIPTION_KEY',
    stateKey: 'description',
  },
  {
    gridXs: 12,
    label: 'EXPIRATION_DATE_KEY',
    stateKey: 'expiration_date',
    isDateTime: true,
    minDate: (moment().add(1, 'days') as unknown) as Date,
  },
  {
    gridXs: 12,
    label: 'PARTNER_KEY',
    stateKey: 'partner_uuid',
    isSelect: true,
  },
];

export default fields;
